import React from "react";
import { Badge } from "@chakra-ui/react";
import { getStatusColor } from "utils/common";

const StatusBadge = ({ status, label, bgColor }) => {
  const { colorScheme, customColor } = getStatusColor(status);
  return (
    <Badge
      colorScheme={bgColor || colorScheme}
      bg={customColor}
      color={customColor ? "white" : undefined} // Set text color to white for custom colors
      variant="solid"
      borderRadius="full"
      px={2}
      py={1}
    >
      {label || status}
    </Badge>
  );
};

export default StatusBadge;
